import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';

@Component({
  selector: 'act-dialog-list',
  templateUrl: './dialog-list.component.html',
  styleUrls: ['./dialog-list.component.scss']
})
export class DialogListComponent implements OnInit, OnDestroy {

  public value;
  public title: string;
  public formCtrl = new FormControl();

  private valueChangesSubscription: Subscription;

  constructor(
    @Inject(MD_DIALOG_DATA) private data: {
      title: string,
      items: [{ name: string, value: string }],
      defaultIndex: number
    },
    private dialogRef: MdDialogRef<DialogListComponent>,
  ) { }

  ngOnInit(): void {
    this.formCtrl.setValue(this.data.items[this.data.defaultIndex].value);
    this.valueChangesSubscription && this.valueChangesSubscription.unsubscribe();
    this.valueChangesSubscription = this.formCtrl.valueChanges
      .subscribe(
        () => this.dialogRef.close(this.formCtrl.value)
      );
  }

  ngOnDestroy() {
    this.valueChangesSubscription && this.valueChangesSubscription.unsubscribe();
  }

  close() {
    this.dialogRef.close(this.formCtrl.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-list/dialog-list.component.ts